import React from "react";
import { useTranslation } from "react-i18next";

// Components
import Modal from "../modal";
import Typography from "../Typography";
import LogoIcon from "../Svgs/LogoIcon";

// Styles
import styles from "./style.module.scss";

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'default' | 'danger';
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  message,
  confirmText,
  cancelText,
  variant = 'default'
}) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const confirmButtonText = confirmText || t('actions.confirm');
  const cancelButtonText = cancelText || t('actions.cancel');

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={""}
      showCloseButton
      className={styles.modal}
    >
      <div className={styles.content}>
        <LogoIcon className={`${styles.logo} text-black dark:text-white`} width={150} height={36} />
        <Typography variant="p" className={styles.message}>
          {message}
        </Typography>

                <div className={styles.actions}>
          <button
            onClick={onClose}
            className={`${styles.cancelButton} text-black dark:text-white dark:bg-stone-650`}
            type="button"
          >
            {cancelButtonText}
          </button>

          <button
            onClick={handleConfirm}
            className={variant === 'danger' ? styles.dangerButton : styles.confirmButton}
            type="button"
          >
            {confirmButtonText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
